// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2Vhti","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1pC84"};